import { Injectable } from '@angular/core';
import { CrudBaseService } from "./crud-base.service";
import { HttpClient } from "@angular/common/http";
import { MedicoPrimaryKey, MedicoModel } from "../models/medico.model";
import { EspecialidadePrimaryKey } from "../models/especialidade.model";

@Injectable({
  providedIn: 'root'
})
export class MedicoService extends CrudBaseService<MedicoModel> {

  constructor(http: HttpClient) {
    super(http, 'medico');
  }

  public getPk(id: MedicoPrimaryKey): MedicoPrimaryKey {
    return Object.assign(new MedicoPrimaryKey(), id);
  }

  public getAllByEspecialidadeId(especialidadeId: EspecialidadePrimaryKey) {
    let pk = Object.assign(new EspecialidadePrimaryKey(), especialidadeId);
    return this.getAllByUrlQuery<MedicoModel>(`${pk.id}`);
  }

  getMedicos(seqSetor: number, status: string) {
    return this.getAllByUrlQuery<MedicoModel[]>(`seqSetor/${seqSetor}/status/${status}`);
  }

}
